import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_H1 = _resolveComponent("H1")!
  const _component_H2 = _resolveComponent("H2")!
  const _component_H3 = _resolveComponent("H3")!
  const _component_H4 = _resolveComponent("H4")!
  const _component_H5 = _resolveComponent("H5")!
  const _component_H6 = _resolveComponent("H6")!

  return (_ctx.as.toUpperCase() === 'H1')
    ? (_openBlock(), _createBlock(_component_H1, {
        key: 0,
        id: _ctx.id,
        style: _normalizeStyle(_ctx.styles),
        "class-name": _ctx.className
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["id", "style", "class-name"]))
    : (_ctx.as.toUpperCase() === 'H2')
      ? (_openBlock(), _createBlock(_component_H2, {
          key: 1,
          id: _ctx.id,
          style: _normalizeStyle(_ctx.styles),
          "class-name": _ctx.className
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["id", "style", "class-name"]))
      : (_ctx.as.toUpperCase() === 'H3')
        ? (_openBlock(), _createBlock(_component_H3, {
            key: 2,
            id: _ctx.id,
            style: _normalizeStyle(_ctx.styles),
            "class-name": _ctx.className
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 8, ["id", "style", "class-name"]))
        : (_ctx.as.toUpperCase() === 'H4')
          ? (_openBlock(), _createBlock(_component_H4, {
              key: 3,
              id: _ctx.id,
              style: _normalizeStyle(_ctx.styles),
              "class-name": _ctx.className
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            }, 8, ["id", "style", "class-name"]))
          : (_ctx.as.toUpperCase() === 'H5')
            ? (_openBlock(), _createBlock(_component_H5, {
                key: 4,
                id: _ctx.id,
                style: _normalizeStyle(_ctx.styles),
                "class-name": _ctx.className
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
              }, 8, ["id", "style", "class-name"]))
            : (_openBlock(), _createBlock(_component_H6, {
                key: 5,
                id: _ctx.id,
                style: _normalizeStyle(_ctx.styles),
                "class-name": _ctx.className
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
              }, 8, ["id", "style", "class-name"]))
}